import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=400e883f&scoped=true"
import script from "./AlertPanel.vue?vue&type=script&lang=ts"
export * from "./AlertPanel.vue?vue&type=script&lang=ts"
import style0 from "./AlertPanel.vue?vue&type=style&index=0&id=400e883f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400e883f",
  null
  
)

export default component.exports